export enum PersonTableFiltersTypes {
  Status = "status",
  Nationality = "nationality",
  Gender = "gender",
}
